// src/navigation/publicNavigationRoutes.js

import { isServiceRoutePath } from './publicServiceRoutes';
import { isAboutRoutePath } from './publicAboutRoutes';

export const publicPrimaryNavigationItems = Object.freeze([
  {
    id: 'home',
    label: 'Home',
    translationKey: 'home',
    path: '/',
  },
  {
    id: 'catalog',
    label: 'Catalog',
    translationKey: 'catalog',
    path: '/app/catalog',
  },
  {
    id: 'insights',
    label: 'Insights',
    translationKey: 'insights',
    path: '/insights',
  },
  {
    id: 'services',
    type: 'services',
    label: 'Services',
    translationKey: 'services',
    path: '/services',
  },
  {
    id: 'about',
    type: 'about',
    label: 'About',
    translationKey: 'about',
    path: '/about',
  },
  {
    id: 'connect',
    label: 'Connect',
    translationKey: 'connect',
    path: '/connect',
  },
]);

export const publicHeaderActions = Object.freeze([
  {
    id: 'open-app',
    label: 'Open App',
    translationKey: 'open_app',
    path: '/app',
  },
]);

export function isCatalogRoutePath(pathname = '') {
  return pathname === '/app/catalog' || pathname.startsWith('/app/catalog/');
}

export function isPublicNavigationItemActive(item, pathname = '') {
  if (item.id === 'services') {
    return isServiceRoutePath(pathname);
  }

  if (item.id === 'about') {
    return isAboutRoutePath(pathname);
  }

  if (item.id === 'catalog') {
    return isCatalogRoutePath(pathname);
  }

  if (item.path === '/') {
    return pathname === '/';
  }

  return pathname === item.path || pathname.startsWith(`${item.path}/`);
}
